import * as React from 'react'
import { ConversationMessageGif } from "../../../../../types";
import MessageParagraph from "../MessageParagraph";
import showdown from '../../../../../utilities/showdown';
import styled from 'styled-components';

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 10px;
  cursor: zoom-in;

  img {
    display: block;
  }
`

interface IProps {
  message: ConversationMessageGif
  onPreviewClick: (url: string) => void
}

const Gif = (props: IProps) => {
  const { message, onPreviewClick } = props

  return (
    <ImageContainer onClick={() => onPreviewClick(message.url)}>
      <img src={message.url} />
    </ImageContainer>
  )
}

export default Gif